import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {isLogin} from '../../functions/Auth';
import Header from '../Headers/Header';
import UserHeader from '../Headers/UserHeader';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },    
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',    
    width: '100%',
    float: 'left',
    background: '#fff',    
    marginTop: '2%',    
    zIndex: '1',
    '& h3': {      
      margin: '0',
      color: '#24618E',      
      '@media only screen and (max-width: 3500px)': { 
        fontSize: '20pt',
        marginTop: '20px',       
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize: '30pt',
        marginTop: '0px',      
      },
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  }, 
  tabblock: {
    border: '1px solid #24618E',
    padding: '10px',      
    borderRadius: '5px',
    width:'100%',
    float:'left', 
    marginBottom: '5px',
    paddingBottom: '10px',  
  },
  tabInnerBlock:{
    width: '100%',
    float: 'left',    
    overflowX: 'hidden',
    overflowY: 'scroll',  
  },
  nonTab: {
    display: 'none',
  },
  helpHead : {
    marginTop:'10px',
    marginBottom:'10px',    
    '@media only screen and (max-width: 3500px)': { 
      fontSize:'18pt',       
    },
    '@media only screen and (min-width: 3501px)': {   
      fontSize:'26pt',  
      marginBottom: '-10px',    
    },
  },
  helpSubHead:{
      marginTop:'10px',            
      '@media only screen and (max-width: 3500px)': { 
        fontSize:'15pt',  
        marginBottom:'-15px',     
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize:'24pt', 
        marginBottom:'-25px',     
      },
  }

}));
//End Css Code ...


//Start Help component Code ...
export default function Help() {

  let scHeight = window.innerHeight;
  
  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    scHeight = window.innerHeight - 165;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    scHeight = window.innerHeight - 175;
  }
  else if (window.screen.width >= 3501) {
    scHeight = window.innerHeight - 235;
  }
  else {
    scHeight = window.innerHeight - 165;
  }

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [imlTab, setImlTab] = React.useState("fo");
  const [screenHeight, setScreenHeight] = React.useState(scHeight);

  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      scHeight = window.innerHeight - 175;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 3501) {
      scHeight = window.innerHeight - 235;
      setScreenHeight(scHeight);
    }
    else {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
  };
  // This code is use to change window viewport height

  //This function is for handle change Tab focusable Start
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <React.Fragment>
      
      { isLogin()  ? <UserHeader/> : <Header/> }

      <div className={classes.mainBlock}>
        <h3>Help</h3>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
        <div className={classes.tabblock} data-testid='all_team_table'>
          <div className={classes.tabInnerBlock} style={{ height: screenHeight.toString() + 'px' }}>
            <ul>
                <li>Signing up for DataPoint
                    <ul>
                        <li>User Management
                            <ul>
                                <li>Teams</li>
                            </ul>
                        </li>
                        <li>
                            Your User Profile
                        </li>
                    </ul>
                </li>
                <li>Getting your data into DataPoint
                    <ul>
                        <li>What kinds of data does DataPoint handle?
                            <ul>
                                <li>Tube Counts</li>
                                <li>Turning movement counts</li>
                            </ul>
                        </li>
                        <li>
                            Supported formats and best practices
                        </li>
                        <li>
                            Creating Stations
                            <ul>
                                <li>Data Management – Station tab</li>
                            </ul>
                        </li>
                        <li>
                            Drag & drop functionality
                            <ul>
                                <li>Import areas</li>
                                <li>Potential issues
                                    <ul>
                                        <li>Missing Station ID?</li>
                                        <li>System identified the wrong station?</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            Approving data for use in DataPoint
                            <ul>
                                <li>Data Management – Import List</li>
                                <li>Potential issues</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>Searching for data
                    <ul>
                        <li>Using the Search Box
                            <ul>
                                <li>What items are valid search criteria?</li>
                                <li>Reading the search results panel</li>
                            </ul>
                        </li>
                        <li>
                            Using the System Layers Panel
                        <ul>
                                <li>Filtering for station data
                                    <ul>
                                        <li>
                                            Symbol clustering
                                        </li>
                                    </ul>
                                </li>
                                <li>Basemap options</li>
                            </ul>
                        </li>
                        <li>Exploring the station locations
                            <ul>
                                <li>Reading the Station Panel
                                    <ul>
                                        <li>
                                            Midblock station
                                        </li>
                                        <li>
                                            Intersection station
                                        </li>
                                    </ul>
                                </li>
                                <li>Station Details screen
                                    <ul>
                                        <li>
                                            Location Details
                                        </li>
                                        <li>
                                            Associated files
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                    </ul>
                </li>
                <li>Exporting Data from DataPoint
                    <ul>
                        <li>Where can I export from?
                            <ul>
                                <li>Search results panel, station details screen</li>
                            </ul>
                        </li>
                        <li>
                            Export process
                        <ul>
                                <li>Select stations dates and data options
                                    <ul>
                                        <li>
                                            Intersection options
                                        </li>
                                        <li>
                                            Midblock options
                                        </li>
                                    </ul>
                                </li>
                                <li>Select format
                                <ul>
                                        <li>
                                            Available export formats
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>What is included in an export?</li>
                    </ul>
                </li>
            </ul>
            <hr style={{ marginTop: '0px' }} />
            <h4 className={classes.helpHead}>Signing Up for DataPoint</h4>

            <h5 className={classes.helpSubHead}>User Management</h5>

            <p>Users can be assigned to agency teams to determine the level of access the user has to the various features of DataPoint.  The names and descriptions of these teams can be customized by the agency if desired.  The three default teams are:</p>



            <ul><li>Admins:  Users who have full access to the DataPoint feature set</li>
                <li>Data Importers: Users who can view and export detailed station data and import data to stations</li>
                <li>Detailed Station Data Viewers: Users who can view and export detailed station data</li></ul>


            <p>A user who is not assigned to one of these teams will be able to use a basic feature set including searching for stations and viewing summary data about those stations.</p>


            <h5 className={classes.helpSubHead}>Your User Profile</h5>
            <p>Users may access their User Profile by clicking their sign-in name in the top right and selecting “My Profile” from the menu.  This panel allows you to update your name, email address, organization, and password.  You may also see the teams to which you have been assigned.</p>

            <h4 className={classes.helpHead}>Getting Your Data into DataPoint</h4>

            <p>DataPoint currently supports data for midblock and intersection station counts.  For midblock stations, this includes volume, vehicle classification, and speed counts.  Intersection stations include vehicle and bicycle turning movements and pedestrian crossing data.</p>



            <p>DataPoint currently supports import files from JAMAR’s TraxPro and PETRAPro software.  The specifics around each of these import formats can be found at our File Import Requirements and Best Practices page.</p>



            <p>Imported data must be assigned to an existing station which can be created by agency admin users.  Imported data must be assigned to an existing station which can be created by agency admin users.  Stations are created in the Data Management tab of the Admin Tools area.  Stations must be either midblock or intersection stations which will determine the type of count data that can be assigned to it.  A station must be assigned a Station Type, a Station ID, and Approach listing.</p>



            <p>Count files can be imported into DataPoint in a few ways:</p>

            <ul>
                <li>Bulk file import from the Import Data link in the top left navigation menu</li>
                <li>Import button from the Station Summary panel</li>
                <li>Import button from the Station Details screen</li>
            </ul>

            <p>Importing the count data from the Station Summary panel or Station Details screen will automatically populate the assigned station as the station displayed in the panel or screen.  The bulk import link allows importers to add files to many different stations at once.  If DataPoint detects the station ID from the file to be imported, the ID will be displayed in the import panel.  Importers are able to change or update the station ID as necessary and assign different station IDs.</p>

            <h5 className={classes.helpSubHead}>Approving Data</h5>

            <p>Before count data can be viewed or used in calculations, it must be approved by an agency administrator.  Files that have been imported can be viewed in the Data Management tab of the Admin Tools area.  This screen displays helpful information and direct links to the imported files to aid in that decision.  Once a file has been approved, it can be viewed in the Files tab of the Station Details screen and if the file contains count data, it will be processed for the appropriate calculations.</p>



            <p>Imported files may encounter errors in processing if DataPoint detects discrepancies in data such as the approach orientation, the file formatting, or missing intervals.  These errors are displayed in the table to allow the agency admin to identify what occurred in the import process.</p>

            <h4 className={classes.helpHead}>Searching for Data</h4>

            <h5 className={classes.helpSubHead}>Using the Search Box</h5>

            <p>The search box appears at the center top of the main map view.  You can enter a road name, a location name, or a station ID to locate the desired station locations and the associated data.  With three or more characters entered, DataPoint will display a list of suggested results beneath the search box.  You can tap the Enter key, click the Search icon, or select one of the suggested results to view the stations that match the criteria that has been entered.  The main map view will zoom to an extent within the agency that can display the suggested results together to provide an understanding of the physical locations of the stations.</p>



            <p>The search results panel appears on the left side of the main map view.  It displays a list of the stations that match the criteria that the user had entered in the search box.  The results are split by station type – midblock or intersection – to better display the associated data types.  Each result block displays the station ID and location as a link to the station summary panel and several icons that display the most recent date of collection of the relevant data.  If a significant number of stations result from the desired search criteria, pagination controls appear at the bottom of the panel that allows more results to be displayed.</p>

            <h5 className={classes.helpSubHead}>Using the System Layers Panel</h5>

            <p>The System Layers panel appears to the left of the Search Box at the top of the screen.  When clicked, it toggles a panel that allows you to view the stations with the types of data you desire.  You can view all the stations in the agency by clicking the Show All Stations button at the top of the panel or you can specify the data types you would like to see by selecting the appropriate filter buttons.  Selecting these buttons and clicking the Show Stations button will filter the display of agency stations to show only those stations that have available data of the type you selected.  You can further filter your selections by narrowing the date range and constraining your visible data to those dates.</p>



            <p>Based on the physical location of the stations, the map view may group the individual stations as a cluster.  The cluster icon will display how many individual stations are contained within it.  Clicking on the cluster icon will zoom in to a closer extent and attempt to display the stations as individual icons.  There may be a second level of clusters depending on how densely packed the stations are and clicking this second level of icon will zoom in to display that selected cluster individually.</p>



            <p>The System Layers panel also contains a selection of basemap options.  Clicking one of the basemap options will change the map view to the depicted styling.</p>

            <h5 className={classes.helpSubHead}>Exploring Station Locations</h5>

            <p>Clicking on a station in the main map view will bring up a summary panel along the left side of the window.  This summary panel displays some basic information about the station.  The display will differ based on whether the station is a midblock station or an intersection station.</p>



            <p>Midblock stations summary panels will display the Station ID and location along with the date of the most recently collected data there.  DataPoint includes a calculation of the average daily traffic (ADT), truck percentage, and ADT annual growth rate over the last three years and plots the ADT values so the trend is easy to view and understand.  A few additional details such as the specific latitude, longitude, and speed limit at the station location are provided at the bottom of the panel.</p>



            <p>Intersection station summary panels display the Station ID, location, and date of the most recently collected data like midblock summary panels but provide summaries of the station’s peak hour on specific dates rather than ADT trends.  The peak hour summary diagrams show the turning movements, truck percentages, and pedestrian and bicycle movements for the selected date.</p>



            <p>Additional details can be viewed if you have been assigned to a team with those permissions.  The Station Details screen contains a number of tabs that display detailed count information and associated visualizations and graphs.  Files that have been associated with the station, such as count data files, photographs, and summaries are included and available for download.  Admin users have the ability to approve the files that are associated with a station as well as remove them from view.  Deleting a file permanently removes it from DataPoint and if the file was a data file, the data is removed from the application and any calculated values are re-calculated with its removal.</p>

            <h4 className={classes.helpHead}>Exporting Data from DataPoint</h4>

            <p>Station data can be exported from DataPoint in .csv format from the Search Results panel and the Station Details screen.  The Search Results panel allows users to select many stations and export that data in bulk rather than exporting from individual stations.</p>



            <p>Selecting a station and clicking the Export button will launch the Export Station Data screen.  This screen acts as a shopping cart to allow users to select the dates and types of data desired.  The export display for intersection stations gives users a view of the available data types for any given date.  The midblock station display provides a more granular selection of data types and allows users to choose whether counts on consecutive days should be exported as a combined file or individual files.</p>



            <p>Additional export options are summarized toward the end of the export process.  Intervals for intersection stations can be displayed in 15- or 5-minute sections.  Midblock intervals have the option of being displayed as 60- or 15-minute sections and can be customized as one- or two-direction reports.</p>



            <p>The .csv exports provide station identification metadata, peak hour summaries, and tabular information consistent with the type of data exported.</p>
        </div>
        </div>
        </div>
      </div>
    </React.Fragment>
  );
}

//End Help component Code ...